module.exports = __webpack_public_path__ + "static/media/flooring_material_60yd_n.bc74fbfc.csv";